import { React, useEffect } from 'react';
import Nav from './nav';
import Tab from './tabs';

function AdminUNCR() {
  return (
    <div className="admin-page">
        <body>
            <Tab/>
      </body>
    </div>
  );
}

export default AdminUNCR;
